enum Permission {
  AccountingErpConnect = 'accounting:erp:connect',
  AccountingErpEdit = 'accounting:erp:edit',
  AccountingErpRead = 'accounting:erp:read',
  AccountingMappingDelete = 'accounting:mapping:delete',
  AccountingMappingRead = 'accounting:mapping:read',
  AccountingMappingUpsert = 'accounting:mapping:upsert',
  AccountingReportRead = 'accounting:report:read',
  PrincipalMarketAnalysisRead = 'principal-market-analysis:read',
  PrincipalMarketAnalysisWrite = 'principal-market-analysis:write',
  SettingAuditLogsRead = 'setting:auditlogs:read',
  SettingCategoryAdd = 'setting:category:add',
  SettingCategoryRead = 'setting:category:read',
  SettingConfigRead = 'setting:config:read',
  SettingConfigEdit = 'setting:config:edit',
  SettingContactDelete = 'setting:contact:delete',
  SettingContactRead = 'setting:contact:read',
  SettingContactUpsert = 'setting:contact:upsert',
  SettingEntityAdd = 'setting:entity:add',
  SettingEntityDelete = 'setting:entity:delete',
  SettingEntityRead = 'setting:entity:read',
  SettingOrgEdit = 'setting:org:edit',
  SettingOrgRead = 'setting:org:read',
  SettingPricingEdit = 'setting:pricing:edit',
  SettingPricingRead = 'setting:pricing:read',
  SettingSpamTokenAdd = 'setting:spam-token:add',
  SettingSpamTokenEnableAutoIngestion = 'setting:spam-token:enable-auto-ingestion',
  SettingSpamTokenDelete = 'setting:spam-token:delete',
  SettingSpamTokenRead = 'setting:spam-token:read',
  SettingTeamDelete = 'setting:team:delete',
  SettingTeamRead = 'setting:team:read',
  SettingTeamUpsert = 'setting:team:upsert',
  TransactionBulkPreviewRead = 'transaction:bulk-preview:read',
  TransactionCustomFieldsDelete = 'transaction:custom-fields:delete',
  TransactionCustomFieldsRead = 'transaction:custom-fields:read',
  TransactionCustomFieldsUpsert = 'transaction:custom-fields:upsert',
  TransactionDashboardRead = 'transaction:dashboard:read',
  TransactionDataAddAttachment = 'transaction:data:add-attachment',
  TransactionDataEdit = 'transaction:data:edit',
  TransactionDataRead = 'transaction:data:read',
  TransactionErpSync = 'transaction:erp:sync',
  TransactionJournalEntryDownload = 'transaction:journal-entry:download',
  TransactionJournalEntryRead = 'transaction:journal-entry:read',
  TransactionRateEdit = 'transaction:rate:edit',
  TransactionRateDelete = 'transaction:rate:delete',
  TransactionRateRead = 'transaction:rate:read',
  TransactionRuleDelete = 'transaction:rule:delete',
  TransactionRuleRead = 'transaction:rule:read',
  TransactionRuleUpsert = 'transaction:rule:upsert',
  TransactionSensitiveDataRead = 'transaction:sensitive-data:read',
  TransactionSourceDelete = 'transaction:source:delete',
  TransactionSourceRead = 'transaction:source:read',
  TransactionSourceUpsert = 'transaction:source:upsert',
  TransactionTokenDownload = 'transaction:token:download',
  TransactionTokenEdit = 'transaction:token:edit',

  // Voucher Permissions
  VoucherView = 'voucher:view',
  VoucherCreate = 'voucher:create',
  VoucherDelete = 'voucher:delete',
  VoucherEdit = 'voucher:edit',
  VoucherReviewerEdit = 'voucher:reviewer-edit',
  VoucherSubmit = 'voucher:submit',
  VoucherAudit = 'voucher:audit',
  VoucherApprove = 'voucher:approve',
  VoucherCertify = 'voucher:certify',
  VoucherRework = 'voucher:rework',
  VoucherSync = 'voucher:sync',
  VoucherWithdraw = 'voucher:withdraw',

  // GENERAL READ
  GeneralAllRead = 'general:all:read',

  // SUPER ADMIN ONLY
  SystemIngestionAdmin = 'system:ingestion:admin',
  SystemSettingAdmin = 'system:setting:admin',
}

export default Permission
